"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  key: 'multiple',
  ignore: true
}, {
  key: 'defaultValue',
  ignore: true
}, {
  key: 'dbIndex',
  ignore: true
}];
exports.default = _default;